import React from 'react';
import { motion } from 'framer-motion';
import { Globe, TrendingUp, Target } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import Accordion from './Accordion';

export default function FranchiseGoals() {
  const { t } = useLang();
  const content = t.franchiseGoals;

  const icons = [Globe, TrendingUp, Target];

  return (
    <section className="relative py-20 md:py-28 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-6xl font-black font-heading text-white mb-4">
            {content.title}
          </h2>
          <p className="text-[#9CA3AF] text-lg md:text-xl">
            {content.subtitle}
          </p>
        </motion.div>

        {/* Goals Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {content.goals.map((goal, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="glass rounded-2xl p-6 text-center hover:scale-105 transition-transform duration-300"
              >
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg, rgba(212,175,55,0.2) 0%, rgba(212,175,55,0.05) 100%)' }}
                >
                  <Icon size={28} className="text-[#D4AF37]" />
                </div>
                <p className="text-white font-semibold text-base md:text-lg">{goal}</p>
              </motion.div>
            );
          })}
        </div>

        {/* Detailed Strategy in Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
        >
          <Accordion title={content.detailsTitle}>
            <ul className="space-y-3">
              {content.detailsList.map((detail, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-[#D4AF37] mt-1.5">•</span>
                  <span className="text-[#E5E7EB] text-base leading-relaxed">{detail}</span>
                </li>
              ))}
            </ul>
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
